<template>
  <el-input v-model="keyword" placeholder="Search room or participant" @input="handleSearch">
     <IconBase
        slot="prefix"
        :width="26"
        :height="26"
        :fill="'#E7E6FA'"
    >
        <IconSearch />
    </IconBase>
  </el-input>
</template>

<script>
import IconBase from '../IconBase'
import IconSearch from '../icons/IconSearch'

export default {
    components: {
        IconBase,
        IconSearch
    },
    data(){
        return {
            keyword: ''
        }
    },
    methods: {
        handleSearch(){
            this.$emit('keyword-changed', this.keyword)
        }
    }
}
</script>

<style scoped>
>>>.el-input__inner {
    background-color: #2F2F3D;
    border-radius: 32px;
    height: 32px;
    width: 100%;
    outline: none;
    border: none;
    color: #E7E6FA;
    margin-bottom: 8px;
}
>>>.el-input__prefix {
    left: 10px;
    top: 9px;
}
</style>